export default {
  title: 'Orari di apertura',
  headers: {
    edit_time: 'Modifica orario',
    create_time: 'Crea orario',
  },
  labels: {
    select_all: 'Seleziona tutto',
    timezone: 'Fuso orario',
  },
  fields: {
    selected_days: {
      label: 'Giorni selezionati',
    },
    opening_time: {
      label: 'Orario di apertura',
    },
    closing_time: {
      label: 'Orario di chiusura',
    },
  },
  columns: {
    days: 'Giorni',
    time: 'Orario',
  },
  buttons: {
    add_opening_time: 'Aggiungi orario di apertura',
    add: 'Aggiungi',
    cancel: 'Annulla',
    save: 'Salva',
    close: 'Chiudi',
    delete: 'Elimina',
    sync_from_online_shop: "Sincronizza dall'Online Shop",
  },
  projects: {
    online_shop: 'Online Shop',
    reservations: 'Prenotazioni',
    storefront: 'Vetrina',
    not_set_up: '{{project}} (non configurato per questa sede)',
  },
  feedback: {
    missing_info: 'Informazioni mancanti',
  },
  toasts: {
    saving_success: 'Salvato con successo',
    saving_error: 'Salvataggio non riuscito. Controlla le informazioni e riprova.',
    sync_success: 'Sincronizzato con successo',
    sync_error: "Sincronizzazione degli orari di apertura dall'online shop non riuscita. Riprova.",
    hours_required: 'Gli orari di apertura sono obbligatori. Modifica gli orari esistenti',
    not_copied: {
      reservations: {
        not_set_up:
          'Le prenotazioni non sono state aggiornate: le prenotazioni non sono ancora configurate per questa sede. La scheda Prenotazioni spiega il motivo.',
        not_matched:
          "Le prenotazioni non sono state aggiornate: lì non esiste l'orario {{time}}. Controlla gli orari nella scheda Prenotazioni.",
        failed: "Impossibile aggiornare le prenotazioni. Usa «Sincronizza dall'Online Shop» nella scheda Prenotazioni.",
      },
      storefront: {
        not_set_up: 'La Vetrina non è stata aggiornata: non è stata trovata nessuna vetrina per questa sede.',
        not_matched:
          "La Vetrina non è stata aggiornata: lì non esiste l'orario {{time}}. Controlla gli orari nella scheda Vetrina.",
        failed: "Impossibile aggiornare la Vetrina. Usa «Sincronizza dall'Online Shop» nella scheda Vetrina.",
      },
    },
  },
  modals: {
    timezone: {
      form: {
        timezone: {
          label: 'Fuso orario',
        },
      },
      toasts: {
        error: 'Aggiornamento del fuso orario non riuscito',
      },
    },
  },
};
